import PicklistMetadata from "../PicklistMetadata";

// Bounded picklist of Account Users (display = Name, value = USID), sourced from the AccountUser EC
// (t5/v1/account_users). Used by the term Permissions tab when adding a DENY_EMPLOYEE constraint.
// Ported from t1's AccountUserPicklistMetadata.
class AccountUserPicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "AccountUser";
        this.bounded = true;
        this.enterpriseComponent = "AccountUser";
        this.longList = false;
        this.noDelete = true;
        this.noUpdate = true;
        this.noInsert = true;
        this.noMerge = true;
        this.useRealm = false;
        this.sortSpecification = [{"SortAttribute": "Name", "Direction": "ASC"}];
        this.static = false;
        this.typeField = "Name";
        this.typeValue = "USID";
        this.allowNoSelection = false;
    }
}

export default AccountUserPicklistMetadata;
